import React from "react";
import DashBoard from "../Pages/ProductionApp/Dashboard/Dashboard";
import GRPOMain from "../Pages/ProductionApp/GRPOViews/GRPOMain";
import ITMain from "../Pages/ProductionApp/InventoryTransferViews/ITMain";
import InvPostingMain from "../Pages/ProductionApp/InventoryPosting/inventoryPosting";
import DeliveryMain from "../Pages/ProductionApp/Deliveryscreen/deliveryMain";
import DisassembleMain from "../Pages/ProductionApp/DisassembleViews/DisassembleMain";
import ProductionFgMain from "../Pages/ProductionApp/ProductionFG/ProductionFgMain";
import Header from "../SharedFiles/Header/Header";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import '../SharedFiles/CommonFile/Style.css';
import BackupQrcode from "../Pages/ProductionApp/BackupQRcode/backupQrcode";
import QRCodeGenerator from "../SharedFiles/QRCode/qrGenerator";
import Return from "../Pages/ProductionApp/Return/Return";
// import Header from "../SharedFiles/Header/Header";

const ProductionRoutes = () => {
    return (
        <>
        <Header/>
            {/* <div className="main-content"> */}
                <Routes>
                    <Route path="/" element={<DashBoard />} />
                    <Route path="/GRPOMain" element={<GRPOMain />} />
                    <Route path="/ITMain" element={<ITMain />} />
                    <Route path="/InventoryPosting" element={<InvPostingMain />} />
                    <Route path="/Delivery" element={<DeliveryMain />} />
                    <Route path="/Return" element={<Return />} />
                    <Route path="/Disassemble" element={<DisassembleMain  />} />
                    <Route path="/ProductionFg" element={<ProductionFgMain />} />
                    <Route path="/generateQr" element={<BackupQrcode />} />
                </Routes>
                <QRCodeGenerator/>
            {/* </div> */}
        </>
    );
};

export default ProductionRoutes;
